import Jsona from "jsona";
import config from "../../config";

import { bannersActions } from "../slices/banner-slice";
import { isEmpty } from "../../library/utils";
import http from "../api/http";

export const fetchAllBanners = (countryCode = "", callback = () => {}) => {
  const apiBaseurl =
    config.REACT_APP_IDENTITY_BASE_URL + config.REACT_APP_BANNERS_URI;

  const params = {
      filter: {
        "banner.countrycode": countryCode,
    },
  };

  const request = http.get(apiBaseurl, { params });

  return (dispatch) => {
    dispatch(
      bannersActions.setLoading({
        isLoading: true,
        willClearError: true,
      })
    );

    request.then(
      ({ data }) => {
        const bannersData = new Jsona().deserialize(data);

        const flatBannerList = [];
        bannersData.forEach((bannerRow) => {
          if (!isEmpty(bannerRow.url1)) {
            flatBannerList.push({
              id: bannerRow.id,
              urlImage: bannerRow.url1,
              bannerType: bannerRow.bannerType,
              description: bannerRow.description,
              redirecturl: bannerRow.redirecturl,
            });
          }

          if (!isEmpty(bannerRow.url2)) {
            flatBannerList.push({
              id: bannerRow.id,
              urlImage: bannerRow.url2,
              bannerType: bannerRow.bannerType,
              description: bannerRow.description,
              redirecturl: bannerRow.redirecturl,
            });
          }
        });

        // for now remove ones without an image
        const filteredBanners = flatBannerList.filter(
          (banner) => String(banner.bannerType).toLowerCase() === "banner"
        );

        const rawAnnouncements = bannersData.filter(
          (banner) => String(banner.bannerType).toLowerCase() === "announcement"
        );
        const flatListAnnouncement = rawAnnouncements.map((bannerRow) => {
          return {
            ...bannerRow,
            urlImage: "",
          };
        });

        // for now remove ones without an image
        dispatch(bannersActions.setBanners(filteredBanners));
        dispatch(bannersActions.setAnnouncements(flatListAnnouncement));

        if (callback) {
          callback(flatBannerList, flatListAnnouncement);
        }
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === "string") {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === "string"
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === "string"
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log("error.response: ", error.response);
          console.log("error.request: ", error.request);
          console.log("error.config: ", error.config);
          if (error.response) {
            errorMessage = "Fetch getUserKYCData failed!";
          }
        }

        console.log("KYC getUserKYCData error: " + errorMessage);

        dispatch(bannersActions.setError(errorMessage));
      }
    );
  };
};

export const setCancelIncoming = (isCancel) => {
  return (dispatch) => {
    dispatch(bannersActions.setCancelIncoming(isCancel));
  };
};

export const clearKYCUserData = () => {
  return (dispatch) => {
    dispatch(bannersActions.clearUserKYCData());
  };
};

export const setBannersModalVisible = (boolVisible = false) => {
  return (dispatch) => {
    dispatch(bannersActions.setBannerVisible(boolVisible));
  };
};

export const setAnnouncementsModalVisible = (boolVisible = false) => {
  return (dispatch) => {
    dispatch(bannersActions.setAnnouncementVisible(boolVisible));
  };
};
